'use client';

function isValidUrl(rdUrl: string): boolean {
    try {
        const url = new URL(rdUrl);
        if (url.protocol !== 'http:' && url.protocol !== 'https:') {
            return false;
        }
        const { hostname } = url;
        return hostname === 'ecoflow.com' || hostname.endsWith('.ecoflow.com');
    } catch {
        return false;
    }
}

function handleForumRedirct(rdUrl?: string) {
    const defaultRedirectUrl = process.env.NEXT_PUBLIC_FORUM_DOMAIN!;
    if (!rdUrl) {
        window.location.href = defaultRedirectUrl;
        return;
    }
    // 判断 rdUrl 是否是合法的 URL 且是社区的URL
    if (!isValidUrl(rdUrl)&&rdUrl.includes('forum')) {
        window.location.href = defaultRedirectUrl;
        return;
    }
    window.location.href = rdUrl;
}

export default handleForumRedirct;
